import { render, staticRenderFns } from "./CargoPremium.vue?vue&type=template&id=189251da&"
import script from "./CargoPremium.vue?vue&type=script&lang=js&"
export * from "./CargoPremium.vue?vue&type=script&lang=js&"
import style0 from "./CargoPremium.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CargoPremium.vue"
export default component.exports